import { computed } from "vue";
import { useStoreItem } from "../itemStore.store";
import { useTargetStore } from "../target/targets.store";
import { useResourceStore } from "../resource/resources.store";
import { useIndexStore } from "../index/indices.store";

import { flowItemStructure, useFlowStore } from "./flows.store";
import { useFlowBranchStore } from "./flowBranches.store";

export const useFlow = useStoreItem(
  flowItemStructure,
  useFlowStore,
  (_flow, store) => {
    const flowBranchStore = useFlowBranchStore();

    const referencedElement = computed(() => {
      const flow = _flow.value;
      if (!flow) return null;
      if (flow.valueInputMode !== "reference") return null;
      const type = flow.valueReferenceType;
      const id = flow.valueReferenceId;
      if (!type || id == null) return null;
      if (type === "target") return useTargetStore().items[id];
      if (type === "resource") return useResourceStore().items[id];
      if (type === "index") return useIndexStore().items[id];
      return null;
    });

    const expression = computed(() => {
      const flow = _flow.value;
      if (!flow) return "";
      if (flow.valueInputMode === "reference") {
        if (!flow.valueReferenceType || flow.valueReferenceId == null) return "";
        return `${flow.valueReferenceType}_${flow.valueReferenceId}`;
      }
      return flow.valueExpression;
    });

    const flowBranches = computed(() => {
      const flow = _flow.value;
      const branches = flowBranchStore.orderedItems.filter(
        (branch) => branch.flowId === flow?.id
      );

      return branches;
    });

    const sourceFlowBranches = computed(() => {
      return flowBranches.value.filter(
        (branch) => branch.branchType === "source"
      );
    });
    const sinkFlowBranches = computed(() => {
      return flowBranches.value.filter(
        (branch) => branch.branchType === "sink"
      );
    });

    const branchValues = computed(() => {
      const values: { [id: number]: number } = {};
      for (const branch of flowBranches.value) {
        values[branch.id] = flowBranchStore.values[branch.id];
      }
      return values;
    });

    const title = computed(() => {
      const flow = _flow.value;
      if (!flow) return "";
      return store.titles[flow.id];
    });

    return {
      referencedElement,
      expression,
      flowBranches,
      sourceFlowBranches,
      sinkFlowBranches,
      branchValues,
      title
    };
  }
);

